import { EventSignUpRegistration } from "../types";

export const getChargeEligibilityClientId = (
  registration: EventSignUpRegistration
): string | null => {
  if (registration.type === "MEMBER" || registration.type === "CUSTOMER") {
    return (
      registration.registrant.playerId || registration.payingMemberId || null
    );
  }

  if (registration.type === "GUEST" || registration.type === "New Guest") {
    return registration.payingMemberId || null;
  }

  return null;
};
